"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShortcutsInfoComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
//@ts-ignore                
let rwsTemplate = T.html `<rws-tooltip side="left" text="${'shortcuts.tooltip-text'.t()}">
    <kbd-key @click="${x => x.showShortcuts()}"><i class="simple-icon-question"></i></kbd-key>
</rws-tooltip>

${(0, fast_element_1.when)(x => x.showModal, (0, fast_element_1.html) `
    <rws-modal 
        name="shortcuts"
        header="shortcuts.title"
        showCloseBtn="true"
        centerTop="true"
        centerLeft="true"
        :closeModal="${x => () => x.hideModal()}"
    >
        <div class="shortcuts-modal-content">            
            <table class="shortcuts-table">
                <thead>
                    <tr>
                        <th class="shortcut-column">${x => 'shortcuts.table.shortcut'.t()}</th>
                        <th class="description-column">${x => 'shortcuts.table.description'.t()}</th>
                    </tr>
                </thead>
                <tbody>
                    ${(0, fast_element_1.repeat)(x => x.shortcuts, (0, fast_element_1.html) `
                        <tr class="shortcut-row">
                            <td class="shortcut-keys">
                                <kbd-key noclick="true">${x => x.key}</kbd-key>
                            </td>
                            <td class="shortcut-description">
                                <div class="shortcut-title">${(x, c) => c.parent.getShortcutTitle(x.titleKey)}</div>
                                <div class="shortcut-desc">${(x, c) => c.parent.getShortcutDescription(x.descriptionKey)}</div>
                            </td>
                        </tr>
                    `)}
                </tbody>
            </table>
        </div>
    </rws-modal>
`)}`;
require("./styles/layout.scss");
const styles = T.css `:host {
  display: inline-block;
}

.shortcuts-modal-content {
  padding: 20px;
  width: 100%;
  background: #ffffff;
}

.shortcuts-table {
  width: 100%;
  border-collapse: collapse;
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.shortcuts-table thead {
  background: #f8fafc;
}
.shortcuts-table thead th {
  padding: 16px;
  text-align: left;
  font-weight: 600;
  color: #475569;
  font-size: 14px;
  border-bottom: 1px solid #e2e8f0;
}
.shortcuts-table thead th.shortcut-column {
  width: 180px;
}
.shortcuts-table thead th.description-column {
  width: auto;
}
.shortcuts-table tbody tr.shortcut-row {
  border-bottom: 1px solid #f1f5f9;
  transition: background-color 0.2s ease;
  background: #ffffff;
}
.shortcuts-table tbody tr.shortcut-row:hover {
  background: #f8fafc;
}
.shortcuts-table tbody tr.shortcut-row:last-child {
  border-bottom: none;
}
.shortcuts-table tbody tr.shortcut-row td {
  padding: 16px;
  vertical-align: top;
}
.shortcuts-table tbody tr.shortcut-row td.shortcut-keys {
  text-align: center;
  background: #f8fafc;
}
.shortcuts-table tbody tr.shortcut-row td.shortcut-description {
  background: #ffffff;
}
.shortcuts-table tbody tr.shortcut-row td.shortcut-description .shortcut-title {
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 4px;
  font-size: 14px;
}
.shortcuts-table tbody tr.shortcut-row td.shortcut-description .shortcut-desc {
  color: #64748b;
  font-size: 13px;
  line-height: 1.4;
}

.keyboard-key {
  display: inline-block;
  padding: 6px 10px;
  border-top: 2px solid #ffffff;
  border-left: 2px solid #ffffff;
  border-right: 2px solid #1e293b;
  border-bottom: 2px solid #1e293b;
  border-radius: 4px;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
  font-weight: 700;
  font-size: 11px;
  color: #1e293b;
  text-align: center;
  min-width: 120px;
  white-space: nowrap;
}`;
const shadowOptions = { "mode": "open" };
let ShortcutsInfoComponent = class ShortcutsInfoComponent extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.showModal = false;
        this.shortcuts = [
            {
                key: 'Ctrl + Alt + K',
                titleKey: 'shortcuts.knowledge.title',
                descriptionKey: 'shortcuts.knowledge.description'
            },
            {
                key: 'Ctrl + Alt + N',
                titleKey: 'shortcuts.new.title',
                descriptionKey: 'shortcuts.new.description'
            },
            {
                key: 'Ctrl + Alt + S',
                titleKey: 'shortcuts.settings.title',
                descriptionKey: 'shortcuts.settings.description'
            },
            {
                key: 'Ctrl + Alt + F',
                titleKey: 'shortcuts.find.title',
                descriptionKey: 'shortcuts.find.description'
            },
            {
                key: 'Ctrl + Alt + P',
                titleKey: 'shortcuts.prompt.title',
                descriptionKey: 'shortcuts.prompt.description'
            }
        ];
    }
    connectedCallback() {
        super.connectedCallback();
        // Listen for close modal events
        this.addEventListener('rws_modal:shortcuts:close', () => {
            this.hideModal();
        });
    }
    showShortcuts() {
        this.showModal = true;
    }
    hideModal() {
        this.showModal = false;
    }
    getShortcutTitle(titleKey) {
        return titleKey.t();
    }
    getShortcutDescription(descriptionKey) {
        return descriptionKey.t();
    }
};
exports.ShortcutsInfoComponent = ShortcutsInfoComponent;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], ShortcutsInfoComponent.prototype, "showModal", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], ShortcutsInfoComponent.prototype, "shortcuts", void 0);
exports.ShortcutsInfoComponent = ShortcutsInfoComponent = __decorate([
    (0, client_1.RWSView)('shortcuts-info', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], ShortcutsInfoComponent);
ShortcutsInfoComponent.defineComponent();
